export default {
  install: function(Vue) {
    Vue.mixin({
      data() {
        return {
          // tableHeight: window.innerHeight - 230,
          tableLoading: false,
          page: 0,
          isTableDataHasMore: true,
          MIXIN_TableLodingText: "正在加载",
          firstLoading: false
        }
      },

      created() {
        this.tableLoadingTimer = null
      },

      computed: {
        // 传参数计算表格高度
        tablesHeight() {
          return function(val) {
            val = val == undefined ? 230 : val
            return window.innerHeight - val
          }
        }
      },

      methods: {
        initScrollTable(isTableDataHasMore = true) {
          this.page = 0
          this.isTableDataHasMore = isTableDataHasMore
        },

        // 用于监听表格滚动，以及加载数据
        scrollLoad(data) {
          this.$emit("tableScroll", data)
          if (this.tableLoading) {
            return
          } else if (
            data.direction === "up" ||
            data.distanceRelativeToBottom > 100
          ) {
            return
          }

          this.tableLoading = true
          // 执行获取数据函数
          if (this.isTableDataHasMore && this.getTableList) {
            let count = 0
            this.tableLoadingTimer = setInterval(() => {
              this.MIXIN_TableLodingText =
                "正在加载" + [".", "..", "..."][count++ % 3]
            }, 350)
            this.getTableList(++this.page)
              .then(datas => {
                this.isTableDataHasMore = datas.has_more
                return datas
              })
              .finally(() => {
                this.tableLoading = false
                clearInterval(this.tableLoadingTimer)
              })
          } else {
            this.tableLoading = false
          }
        },

        openMessage(code, message, options = {}) {
          let type
          switch (code) {
            case 0:
              type = "error"
              break
            case 1:
              type = "success"
              break
            case 2:
              type = "info"
              break
            case 3:
              type = "warning"
              break
            default:
              break
          }
          this.$message.closeAll() // 新的实例出现前先关闭其它现有实例
          this.$message({
            type,
            message,
            showClose: true,
            duration: options.duration || 1500
          })
        },

        openNotify(code, message, title) {
          let type, typeText
          switch (code) {
            case 0:
              type = "error"
              typeText = "失败"
              break
            case 1:
              type = "success"
              typeText = "成功"
              break
            case 2:
              type = "info"
              typeText = "提示"
              break
            case 3:
              type = "warning"
              typeText = "警告"
              break
            default:
              break
          }
          this.$notify({
            title: title || typeText,
            message: message,
            type: type
          })
        },

        clearObject(obj) {
          // 清空(不是删除)一个对象的所有属性
          for (var key in obj) {
            obj[key] = ""
          }
        },

        cloneObject(obj) {
          // 深克隆一个对象
          return JSON.parse(JSON.stringify(obj))
        },

        confirm(message, options, sureBack, cancleBack) {
          let defOPtions = {
            title: "系统提示"
          }
          defOPtions = { ...defOPtions, ...options }
          this.$confirm(message, defOPtions)
            .then(() => {
              sureBack && sureBack()
            })
            .catch(() => {
              cancleBack && cancleBack()
            })
        },

        //异步更新队列
        async nextTick(beforeTick, afterTick) {
          beforeTick && beforeTick()
          await this.$nextTick()
          afterTick && afterTick()
        },

        uniqueNameForImg(type) {
          return type + '/' + (+new Date()) + '-' + Math.floor(Math.random(1) * 1000000) + '.jpg'
        },

        uniqueNameForCertify(type, suffix = '.pfx') {
          return type + '/' + (+new Date()) + '-' + Math.floor(Math.random(1) * 1000000) + suffix
        }
      }
    })
  }
}
